/**
 * Radial meter arc maths, separated from the component for node-project testing.
 */

export interface MeterArcOptions {
  radius: number;
  strokeWidth: number;
}

export interface MeterArc {
  circumference: number;
  /** `stroke-dashoffset` for the progress ring. */
  offset: number;
}

export function describeMeterArc(value: number, { radius }: MeterArcOptions): MeterArc {
  const circumference = 2 * Math.PI * radius;
  // A NaN or Infinity here would reach the DOM as `stroke-dashoffset="NaN"` and
  // silently blank the ring, so it is normalised to an empty meter instead.
  const safe = Number.isFinite(value) ? Math.min(100, Math.max(0, value)) : 0;
  return { circumference, offset: circumference * (1 - safe / 100) };
}
